(function($){

	$(document).ready(function() {

		$('#mobilemenuModal').on('show.bs.modal',function(e){
			$('#site-header').addClass('mobileMenu-open');
			$('.mobile-triggers .menu-icon').addClass('mobileMenu-open');
			$('#mobilemenuModal').addClass('slide');
		});

		$('#mobilemenuModal').on('hide.bs.modal',function(e){
			$('.mobile-triggers .menu-icon').removeClass('mobileMenu-open');
			$('#mobilemenuModal').removeClass('slide');
		});

		$('#mobilemenuModal').on('hidden.bs.modal',function(e){
			$('#site-header').removeClass('mobileMenu-open');
		});

	});
	
})(jQuery);